enum RecoilLoadableStateEnum {
  HAS_ERROR = 'hasError',
  HAS_VALUE = 'hasValue',
  LOADING = 'loading',
}

export default RecoilLoadableStateEnum;
